import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "BaseSidePanelSection" }
const _hoisted_2 = {
  key: 0,
  class: "BaseSidePanelSection__section-header bg-white q-mb-12"
}
const _hoisted_3 = { class: "BaseSidePanelSection__section-content" }

interface IProps {
  title?: string
  titleColor?: string
  borderless?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseSidePanelSection' },
  __name: 'BaseSidePanelSection',
  props: {
    title: { default: '' },
    titleColor: { default: 'cool-gray-100' },
    borderless: { type: Boolean, default: false }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _component_k_divider = _resolveComponent("k-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.title !== '' || _ctx.$slots['title'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "title", {}, () => [
            _createElementVNode("span", {
              class: _normalizeClass(["block fs-15px fw-600 q-pb-sm", `text-${__props.titleColor}`])
            }, _toDisplayString(__props.title), 3 /* TEXT, CLASS */)
          ]),
          (!__props.borderless)
            ? (_openBlock(), _createBlock(_component_k_divider, {
                key: 0,
                size: "md",
                color: "cool-gray-30"
              }))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})